export const players = [{
  id: 'xx',
  color: '#ff4500',
  labelType: 'success',
  status: 'Ready',
}, {
  id: 'yy',
  color: '#ff8c00',
  labelType: 'info',
  status: 'Pending',
}];

export const predefinedColors = [
  '#ff4500',
  '#ff8c00',
  '#ffd700',
  '#90ee90',
  '#00ced1',
  '#1e90ff',
  '#c71585',
];
